module.exports = __webpack_public_path__ + "media/images/version_merge/doc_upload_doc-4ed4ed85cc80fd5719330f0b964ef1ab.png";